import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const arrowCtaDefaultVariants = {}
const arrowCtaCompoundVariants = []

const arrowCtaSlotNames = [
  [
    "root",
    "arrow-cta__root"
  ],
  [
    "icon",
    "arrow-cta__icon"
  ],
  [
    "text",
    "arrow-cta__text"
  ]
]
const arrowCtaSlotFns = /* @__PURE__ */ arrowCtaSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, arrowCtaDefaultVariants, getSlotCompoundVariant(arrowCtaCompoundVariants, slotName))])

const arrowCtaFn = memo((props = {}) => {
  return Object.fromEntries(arrowCtaSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const arrowCtaVariantKeys = []
const getVariantProps = (variants) => ({ ...arrowCtaDefaultVariants, ...compact(variants) })

export const arrowCta = /* @__PURE__ */ Object.assign(arrowCtaFn, {
  __recipe__: false,
  __name__: 'arrowCta',
  raw: (props) => props,
  variantKeys: arrowCtaVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, arrowCtaVariantKeys)
  },
  getVariantProps
})